import React, { Component } from 'react';
import MyStepZilla from '../MyStepZilla'
import Step1 from '../Steps/PharmacyCoordinate'
import Step3 from '../Steps/BankAccountInformation'
import Step2 from '../Steps/Order'
import Step5 from '../Steps/Validation'
import Step4 from '../Steps/EndStep'
import Config from '../../config.js'

export default class Wizard extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.sampleStore = {
      pharmacy: {
        program: Config.program.id,
        coordinate: {
          finessNumber: "",
          cipNumber:"",
          rcs:"",
          name: "",
          address: "",
          siret: "",
          zipcode: "",
          city: "",
          email: "",
          phoneNumber: "",
          capital: 0
        },
        hasPaymentDay: false,
        hasCheckedGeneralCondition: false,
        selectedTurnover: -1,
        selectedSoftware: -1,
        softwareOther: "",
        softwareWillChange: false,
        softwareHasChanged: false,
        softwareOtherFuture: "",
        communicationMonth: -1,
        genericLabs:"",
        businessHours: [
          {name: "Lundi", isOpen: true, hours: ""},
          {name: "Mardi", isOpen: true, hours: ""},
          {name: "Mercredi", isOpen: true, hours: ""},
          {name: "Jeudi", isOpen: true, hours: ""},
          {name: "Vendredi", isOpen: true, hours: ""},
          {name: "Samedi", isOpen: true, hours: ""},
          {name: "Dimanche", isOpen: false, hours: ""},
        ],
        responsibles: [
          {
            type: 0,
            capacity: "Responsable de la pharmacie",
            quality: "",
            lastName: "",
            firstName: "",
            email: "",
            phoneNumber: "",
            fax: ""
          },
        ],
        order: {
          packs: [
            { name: "Pack de 600 cartes", price: 600, quantity: 1 },
            { name: "Pack de 1000 cartes", price: 1000, quantity: 1 },
          ],
          hasPack: true,
          hasEmail: true,
          hasSms: false,
          hasMail: false
        }
      },
      softwares: [
        { id: 1, name: "LGPI" }, 
        { id: 2, name: "Winpharma" },
        { id: 3, name: "Vindilis" },
        { id: 4, name: "Aliance Premium" }, 
        { id: 5, name: "Opus" },
        { id: 6, name: "Autre" },
      ],
      turnovers: [
        { id: 1, type: 1, name: "(inf. 1M €)" },
        { id: 2, type: 2, name: "(1 à 2 M €)" },
        { id: 3, type: 3, name: "(2 à 3 M €)" },
        { id: 4, type: 4, name: "(sup. à 3M €)" },
      ],
      bankAccount: {
        coordinate: {
          name: "",
          address: "",
          zipcode: "",
          city: "",
          country: "",
        },
        bankCoordinate: {
          bank_name: "",
          address: "",
          zipcode: "",
          city: "",
          country: "",
        },
        account: {
          iban: "",
          bic: "",
          file: null,
        },
      },
      signature: null,
      savedToCloud: false,
    };
    if (Config.isTest) {
      this.sampleStore = {
        pharmacy: {
          program: Config.program.id,
          coordinate: {
            finessNumber: "123456789",
            cipNumber:"1234567",
            rcs:"Strasbourg",
            name: "Pharmacie du centre",
            address: "15 rue des champs",
            siret: "11111111111111",
            zipcode: "68000",
            city: "Colmar",
            phoneNumber: "0329292929",
            fax: "0389898989",
            capital: 1200000
          },
          hasPaymentDay: false,
          hasCheckedGeneralCondition: true,
          selectedTurnover: 2,
          selectedSoftware: 2,
          softwareOther: "",
          softwareWillChange: true,
          softwareHasChanged: false,
          softwareOtherFuture : "LGPI",
          communicationMonth: 2,
          genericLabs:"",
          businessHours: [
            {name: "Lundi", isOpen: true, hours: ""},
            {name: "Mardi", isOpen: true, hours: ""},
            {name: "Mercredi", isOpen: true, hours: ""},
            {name: "Jeudi", isOpen: true, hours: ""},
            {name: "Vendredi", isOpen: true, hours: ""},
            {name: "Samedi", isOpen: true, hours: ""},
            {name: "Dimanche", isOpen: false, hours: ""},
          ],
          responsibles: [
            {
              type: 0,
              capacity: "Responsable de la pharmacie",
              quality: "Gérant",
              lastName: "BUCHINGER",
              firstName: "Mickael",
              email: "jonathanhurtrel@groupeuniverspharmacie.com",
              phoneNumber: "0651933115",
            },
          ],
          order: {
            packs: [
              {name: "Pack de 600 cartes", price: 600, quantity: 1},
              {name: "Pack de 1000 cartes", price: 1000, quantity: 1},
            ],
            hasPack: true,
            hasEmail: true,
            hasSms: false,
            hasMail: false
          }
        },
        softwares: [
          {id: 1, name: "LGPI"},
          {id: 2, name: "Winpharma"},
          {id: 3, name: "Vindilis"},
          {id: 4, name: "Aliance Premium"},
          {id: 5, name: "Opus"},
          {id: 6, name: "Autre"},
        ],
        turnovers: [
          {id: 1, type: 1, name: "(inf. 1M €)"},
          {id: 2, type: 2, name: "(1 à 2 M €)"},
          {id: 3, type: 3, name: "(2 à 3 M €)"},
          {id: 4, type: 4, name: "(sup. à 3M €)"},
        ],
        bankAccount: {
          coordinate: {
            name: "",
            address: "",
            zipcode: "",
            city: "",
            country: "FRANCE",
          },
          bankCoordinate: {
            bank_name: "HSBC",
            address: "6 rue des clefs",
            zipcode: "68000",
            city: "Colmar",
            country: "FRANCE",
          },
          account: {
            iban: "FR0000000000000000000000000",
            bic: "FRFRFRFR123",
            file: null,
          },
        },
        signature: null,
        savedToCloud: false,
      }
    }
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getStore() {
    return this.sampleStore;
  }

  updateStore(update) {
    this.sampleStore = {
      ...this.sampleStore,
      ...update,
    }
  }

  render() {
    window.scrollTo(0, 0);

    const steps =
    [
      {name: 'Informations sur la pharmacie', component: <Step1 getStore={() => (this.getStore())} updateStore={(u) => {this.updateStore(u)}} intStep={0} />},
      /*{name: 'Kit de démarrage', component: <Step2 getStore={() => (this.getStore())} updateStore={(u) => {this.updateStore(u)}} />},*/
      {name: 'Autorisation de prélèvement', component: <Step3 getStore={() => (this.getStore())} updateStore={(u) => {this.updateStore(u)}} intStep={1} />},
      {name: 'Génération du contrat', component: <Step4 getStore={() => (this.getStore())} updateStore={(u) => {this.updateStore(u)}} intStep={2} />},
      {name: 'Validation par SMS', component: <Step5 getStore={() => (this.getStore())} updateStore={(u) => {this.updateStore(u)}} intStep={3} />, displayNavigation: false},
    ]

    return (
      <div className='example'>
        <div className='step-progress'>
          <MyStepZilla
            steps={steps}
            preventEnterSubmission={true}
            nextTextOnFinalActionStep={"Terminer l'inscription"}
            hocValidationAppliedTo={[]}
            startAtStep={0}
            nextButtonText="Suivant"
            backButtonText="Précédent"
            nextButtonCls={"btn btn-prev btn-lg pull-right btn-primary-program-"+Config.program.style }
            backButtonCls={"btn btn-next btn-lg pull-left btn-primary-program-"+Config.program.style }
            stepsNavigation={false}
           />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Wizard/index.js